import { Button as ButtonComponent } from '@opinary/ui-components'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  text-align: center;
`

export const Title = styled.h1`
  font-size: 24px;
  margin: 0;
  color: #fff;
`

export const Subtitle = styled.h2`
  font-size: 18px;
  margin: 10px 0 20px 0;
  color: #fff;
`

export const Button = styled(ButtonComponent)`
  background-color: #f9a524;
  &:hover {
    opacity: 0.9;
    background-color: #f9a524;
  }
`
